import * as actions from "../action.constants";

export const createUpdateCustomFields = (payload, callback = () => {}) => ({
  type: actions.CREATE_UPDATE_CUSTOM_FIELDS,
  payload,
  callback,
});

export const requestCustomFields = (pageUrl) => ({
  type: actions.REQUEST_CUSTOM_FIELDS,
  pageUrl,
});

export const storeCustomFields = (data) => ({
  type: actions.STORE_CUSTOM_FIELDS,
  payload: data,
});

export const deleteCustomField = (id, callback = () => {}) => ({
  type: actions.DELETE_CUSTOM_FIELDS,
  id,
  callback,
});

export const requestObjectTypes = () => ({
  type: actions.REQUEST_OBJECT_TYPES,
});

export const storeObjectTypes = (data) => ({
  type: actions.STORE_OBJECT_TYPES,
  payload: data,
});

export const requestRelatedObjectTypes = () => ({
  type: actions.REQUEST_RELATED_OBJECT_TYPES,
});

export const storeRelatedObjectTypes = (data) => ({
  type: actions.STORE_RELATED_OBJECT_TYPES,
  payload: data,
});

export const requestFieldTypes = () => ({
  type: actions.REQUEST_FIELD_TYPES,
});

export const storeFieldTypes = (data) => ({
  type: actions.STORE_FIELD_TYPES,
  payload: data,
});

export const createUpdateCustomFieldChoices = (payload, callback = () => {}) => ({
  type: actions.CREATE_UPDATE_CUSTOM_FIELD_CHOICES,
  payload,
  callback,
});

export const requestCustomFieldChoices = (pageUrl) => ({
  type: actions.REQUEST_CUSTOM_FIELD_CHOICES,
  pageUrl,
});

export const storeCustomFieldChoices = (data) => ({
  type: actions.STORE_CUSTOM_FIELD_CHOICES,
  payload: data,
});

export const deleteCustomFieldChoices = (id, callback = () => {}) => ({
  type: actions.DELETE_CUSTOM_FIELD_CHOICES,
  id,
  callback,
});

export const requestCustomFieldChoicesLabelValue = () => ({
  type: actions.REQUEST_CUSTOM_FIELD_CHOICES_LABEL_VALUE,
});

export const storeCustomFieldChoicesLabelValue = (data) => ({
  type: actions.STORE_CUSTOM_FIELD_CHOICES_LABEL_VALUE,
  payload: data,
});
